function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:transparent;stroke:#707070;stroke-miterlimit:10;stroke-width:3px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "prefix__tacos-03",
  transform: "translate(1.54 1.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_304",
  d: "M10.026 33.59C6.678 22.774 20.069 11.7 23.417 11.7S46.852 51.1 53.29 55.994c10.044 7.726 15.452 2.833 20.6 2.575S97.328 63.72 97.328 68.1 62.819 80.459 53.29 77.884 36.809 45.693 10.026 33.59z",
  className: "prefix__cls-1",
  "data-name": "Path 304",
  transform: "translate(-9.493 -11.7)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_305",
  d: "M9.7 20.2c4.12 4.893 1.03 45.324 6.438 45.324S15.108 30.5 22.834 28.7",
  className: "prefix__cls-1",
  "data-name": "Path 305",
  transform: "translate(-9.167 1.69)"
}));

var SvgTacos03 = function SvgTacos03(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90.874,
    height: 70.214,
    viewBox: "0 0 90.874 70.214",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTacos03, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tacos-03.91300187.svg";
export { ForwardRef as ReactComponent };